import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Login from './pages/usersPages/Login';
import MainRoutes from './MainRoutes';
import requiresAuth from './hocs/requiresAuth';

const AppRouter = (props) => {
    return (
        <Router>
            <Switch>
                <Route exact path="/login" component={Login} />
                <Route path="/" component={requiresAuth(MainRoutes)} />
            </Switch>
        </Router>
    );
};

export default AppRouter;
